import React, { useState } from "react";
import "./App.css";
import "./index.css";
import "./components/common/common_css/Common_Form_Css.css";
import { useLocation } from "react-router-dom";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Volunteering from "./components/volunteering/Volunteering";
import Volunteering_description from "./components/volunteering/volunteering-description/Volunteering_description";
import Volunteer_step_form from "./components/volunteering/volunteer_step_form/Volunteer_step_form";
import Donate from "./components/donate/Donate";
import Insight from "./components/insight/Insight";
import Gurudev from "./components/gurudev/Gurudev";
import Contact_Us from "./components/contact_us/Contact_Us";
import Meditation_blog_details from "./components/meditation-blog-details/Meditation_blog_details";
import Spandan from "./components/spandan/Spandan";
import Explore from "./components/explore/Explore";
import Notification from "./components/notification/Notification";
import Panic_Healing from "./components/panic_healing/Panic_Healing";
import Profile from "./components/profile/Profile";
import Edit_Profile from "./components/profile/edit_profile/Edit_Profile";
import Settings from "./components/profile/settings/Settings";

import Product_description from "./components/product-description/Product_description";
import Order_details from "./components/profile/right_side_content/inner_details_pages/order_details/Order_details";
import Cancel_order from "./components/profile/right_side_content/inner_details_pages/cancel_order/Cancel_order";
import Delivered_Order_Details from "./components/profile/right_side_content/inner_details_pages/delivered_order_details/Delivered_Order_Details";
import All_Quotes from "./components/all_quotes/All_Quotes";
import SavedAddress from "./components/Address/SavedAddress/SavedAddress";
import AddNewAddress from "./components/Address/AddNewAddress/AddNewAddress";
import About_Us from "./components/about_us/About_Us";
import Checkout from "./components/checkout/Checkout";
import CheckoutRoom from "./components/checkout-room/Checkout_Room";
import Cancelled_Order_Details from "./components/profile/right_side_content/inner_details_pages/cancelled_order_details/Cancelled_Order_Details";
import Wishlist from "./components/wishlist/Wishlist";
import Add_wallet from "./components/add-wallet/Add_wallet";
import Visson_Misson from "./components/visson_misson/Visson_Misson";
import Inner_Calm_Meditation from "./components/inner_calm_meditation/Inner_Calm_Meditation";
import Sadguru_arpanam from "./components/sadguru-arpanam/Sadguru_arpanam";
import Sadguru_arpanam_event_join_form from "./components/sadguru-arpanam/sadguru-arpanam-event-join-form/Sadguru_arpanam_event_join_form";
import All_Meditations from "./components/all_meditations/All_Meditations";
import Explore_Latest_Products from "./components/explore_latest_products/Explore_Latest_Products";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Guest_house from "./components/guest-house/Guest_house";
import Guest_house_details from "./components/guest-house/guest-house-details/Guest_house_details";
import Event_Registration from "./components/event_registration/Event_Registration";
import Near_By_Events from "./components/near_by_events/Near_By_Events";
import Program_Details from "./components/program_details/Program_Details";
import Cart from "./components/cart/Cart";
import All_Shibir from "./components/all_shibir/All_Shibir";
import Shibir_Registration from "./components/shibir_registration/Shibir_Registration";
import Personal_Info_Form from "./components/personal_info_form/Personal_Info_Form";
import Seva_Logbook from "./components/seva_logbook/Seva_Logbook";
import Seva_Logbook_Details from "./components/seva_logbook_details/Seva_Logbook_Details";
import Seva_Logbook_History from "./components/seva_logbook_history/Seva_Logbook_History";
import Donation_Tracker from "./components/donation_tracker/Donation_Tracker";
import Journey_within from "./components/profile/right_side_content/spiritual_dashboard/journey-within/Journey_within";
import Shibir_inner from "./components/profile/right_side_content/spiritual_dashboard/shibir-inner/Shibir_inner";
import Have_A_Question from "./components/have_a_question/Have_A_Question";
import All_latest_articles from "./components/insight/latest_articles/All_latest_articles";
import Aticle_description from "./components/insight/latest_articles/Aticle_description";
import All_latest_videos from "./components/insight/latest_videos/All_latest_videos";
import All_latest_audio from "./components/insight/latest_audio/All_latest_audio";
import Gallery_frames from "./components/gallery-component/gallery-frames/Gallery_frames";
import Gallery_slider from "./components/gallery-component/gallery-slider/Gallery_slider";
import Sankalp_Notes from "./components/sankalp_notes/Sankalp_Notes";
import Welcome_video from "./components/welcome-video/Welcome_video";
import Event_Details from "./components/event_details/Event_Details";
import Annadanam from "./components/annadanam/Annadanam";
import All_albums from "./components/all-albums/All_albums";
import Track_Order from "./components/track_order/Track_Order";
import All_Products from "./components/explore_latest_products/all_products/All_Products";
import Spandan_Register_Form from "./components/spandan_register_form/Spandan_Register_Form";
import Whatsapp_Lottie from "./components/animation/whatsapp_lottie/Whatsapp_Lottie";
import All_Album_Chants from "./components/all_album_chants/All_Album_Chants";
import Annadanam_Content_step_2 from "./components/annadanam/annadanam_content/annadanam_Content_step_2/Annadanam_Content_step_2";
import Attendance_Form from "./components/attendance_form/Attendance_form";
import Return_order from "./components/profile/right_side_content/inner_details_pages/return_order/Return_order";
import Returned_Order_Details from "./components/profile/right_side_content/inner_details_pages/returned_order_details/Returned_Order_Details";
import Concent_Terms_Conditions from "./components/concent_terms_conditions/Concent_Terms_Conditions";
import NotFound from "./components/common/common_components/not_found/Not_Found";
import Not_Found from "./components/common/common_components/not_found/Not_Found";

function App() {

  const { pathname } = useLocation();
  const [addressId, setAddressId] = useState(null);
  const [orderAddress, setOrderAddress] = useState({});
  const [deliveryNote, setDeliveryNote] = useState("");
  return (
    <>
      <ScrollToTop />

      {/* {pathname.startsWith("/") ? null : <Header />} */}
      {pathname === "/" ? "" : <Header />}

      <Routes>
        <Route path="/" element={<Welcome_video />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/volunteer" element={<Volunteering />} />
        <Route path="/volunteer-details/:id" element={<Volunteering_description />} />
        <Route path="/volunteer-stepform/:id" element={<Volunteer_step_form />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/insight" element={<Insight />} />
        <Route path="/gurudev" element={<Gurudev />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route
          path="/meditation-blog-details/:id"
          element={<Meditation_blog_details />}
        />
        <Route path="/spandan" element={<Spandan />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/panic-healing/:id" element={<Panic_Healing />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/edit-profile" element={<Edit_Profile />} />
        <Route path="/settings/*" element={<Settings />} />

        <Route path="/order-details/:id" element={<Order_details />} />
        <Route path="/cancel-order/:id" element={<Cancel_order />} />
        <Route path="/return-order/:id" element={<Return_order />} />
        <Route path="/product-details/:id" element={<Product_description />} />
        <Route
          path="/delivered-order-details/:id"
          element={<Delivered_Order_Details />}
        />
        <Route
          path="/cancelled-order-details/:id"
          element={<Cancelled_Order_Details />}
        />
        <Route
          path="/returned-order-details/:id"
          element={<Returned_Order_Details />}
        />
        <Route path="/all-quotes" element={<All_Quotes />} />
        <Route path="/saved-address" element={<SavedAddress
          addressId={addressId}
          setAddressId={setAddressId}
          orderAddress={orderAddress}
          setOrderAddress={setOrderAddress} />} />
        <Route path="/add-new-address" element={<AddNewAddress addressId={addressId} setAddressId={setAddressId} />} />
        {/* <Route path="/add-new-address/" element={<AddNewAddress addressId={addressId} setAddressId={setAddressId} />} /> */}
        <Route path="/checkout" element={<Checkout orderAddress={orderAddress}
          setOrderAddress={setOrderAddress} setDeliveryNote={setDeliveryNote} deliveryNote={deliveryNote} />} />

        <Route path="/checkout-room/:id" element={<CheckoutRoom />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/add-wallet" element={<Add_wallet />} />
        <Route path="/vision-mission" element={<Visson_Misson />} />
        <Route
          path="/inner-calm-meditation/:id"
          element={<Inner_Calm_Meditation />}
        />
        <Route path="/sadguru-arpanam/:id" element={<Sadguru_arpanam />} />
        <Route
          path="/join-event"
          element={<Sadguru_arpanam_event_join_form />}
        />
        <Route path="/all-meditations" element={<All_Meditations />} />
        <Route
          path="/explore-latest-products"
          element={<Explore_Latest_Products />}
        />
        <Route path="/guest-house" element={<Guest_house />} />
        <Route path="/guest-house-details/:id" element={<Guest_house_details />} />
        <Route path="/event-registration" element={<Event_Registration />} />
        <Route path="/near-by-events" element={<Near_By_Events />} />
        <Route path="/program-details/:id" element={<Program_Details />} />
        <Route path="/cart" element={<Cart setDeliveryNote={setDeliveryNote} deliveryNote={deliveryNote} />} />
        <Route path="/all-shibir" element={<All_Shibir />} />
        <Route path="/shibir-registration/:id" element={<Shibir_Registration />} />
        <Route path="/personal-info-form/:id" element={<Personal_Info_Form />} />
        <Route path="/seva-logbook" element={<Seva_Logbook />} />
        <Route path="/seva-logbook-details/:id" element={<Seva_Logbook_Details />} />
        <Route path="/seva-logbook-history" element={<Seva_Logbook_History />} />
        <Route path="/donation-tracker" element={<Donation_Tracker />} />
        <Route path="/journey-within" element={<Journey_within />} />
        <Route path="/shibir-inner" element={<Shibir_inner />} />
        <Route path="/have-a-question" element={<Have_A_Question />} />
        <Route path="/all-articles" element={<All_latest_articles />} />
        <Route path="/article-description/:id" element={<Aticle_description />} />
        <Route path="/all-latest-videos" element={<All_latest_videos />} />
        <Route path="/all-latest-audio" element={<All_latest_audio />} />
        <Route path="/gallery-frames" element={<Gallery_frames />} />
        <Route path="/gallery-slider/:id" element={<Gallery_slider />} />
        <Route path="/sankalp-notes" element={<Sankalp_Notes />} />
        <Route path="/event-details" element={<Event_Details />} />
        <Route path="/annadanam/:id" element={<Annadanam />} />
        <Route path="/donation-step-2/:id" element={<Annadanam_Content_step_2 />} />
        <Route path="/all-albums" element={<All_albums />} />
        <Route path="/all-album-chants/:id" element={<All_Album_Chants />} />
        <Route path="/track-order/:id" element={<Track_Order />} />
        <Route path="/all-products" element={<All_Products />} />
        <Route path="/spandan-register-form" element={<Spandan_Register_Form />} />
        <Route path="/attendance-form" element={<Attendance_Form />} />
        <Route path="/consent" element={<Concent_Terms_Conditions />} />
        <Route path="*" element={<Not_Found />} />
        

      </Routes>

      {/* {pathname.startsWith("/") ? null : <Footer />} */}
      {pathname === "/" ? "" : <Footer />}

      {/* {pathname === "/" ? "" : <Whatsapp_Lottie />} */}

    </>
  );
}

export default App;
